import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface ServerTimeResponse {
  success: boolean;
  formatted_time: string;
}

export function useServerTime() {
  return useQuery({
    queryKey: ['home', 'server-time'],
    queryFn: async () => {
      const { data } = await api.get<ServerTimeResponse>('/api/v1/home/server-time');
      return data;
    },
    refetchInterval: 1000,
    staleTime: 0,
  });
}
